import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './user.routes';
import addHtml from './modal/add.html';
import areviewHtml from './modal/review.html';
import maxImageHtml from './modal/maximage.html';



export class UserController {
    $http;
    socket;
    awesomeThings = [];
    awesomeUsers = [];
    newThing = '';

    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location, $timeout, $rootScope) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;

        this.reviewStatus = [
            { value: 0, name: '待审核' },
            { value: 1, name: '审核驳回' },
            { value: 2, name: '审核通过' },
        ];

        this.loginType = [
            { value: 'email', name: 'email' },
            { value: 'google', name: 'google' },
            { value: 'fb', name: 'fb' },
            { value: 'apple', name: 'apple' },
        ]


        $scope.$on('$destroy', function () {
            socket.unsyncUpdates('thing');
        });
    }

    TransformationStatus(value) {
        var ret = _.find(this.reviewStatus, { value: value });
        if (ret) {
            return ret.name;
        }
        return '';
    }

    $onInit() {



        if (this.$cookies.get('token')) {

            this.$http.get('/api/users/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: {
                    'page': 0,
                    'size': 20
                }
            })
                .then(response => {
                    if (response.data.data) {
                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.currentPage = 1;

                        angular.forEach(response.data.data, function (item) {
                            if (item.images && item.images.indexOf('http') === -1) {
                                item.images = 'https://www.bibliagratis.mobi' + item.images;
                            }
                        });


                        this.awesomeUsers = response.data.data;
                        this.socket.syncUpdates('user', this.awesomeUsers);
                    }

                });
        } else {
            this.$location.path('main')
        }
    }


    search(val) {
        if (val === true) {
            this.currentPage = 1;
        }
        const payload = angular.copy(this.filters);
        if (val === true && payload.user_id) {
            payload.user_id = parseInt(payload.user_id, 10);
        }

        if (val === true && payload.status) {
            payload.status = parseInt(payload.status, 10);
        }


        const ret = {
            filters: payload || {},
            page: this.currentPage - 1,
            size: 20
        };
        if (this.$cookies.get('token')) {
            this.$http.get('/api/users/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: ret
            })
                .then(response => {
                    if (response.data.data) {
                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        angular.forEach(response.data.data, function (item) {
                            if (item.images && item.images.indexOf('http') === -1) {
                                item.images = 'https://www.bibliagratis.mobi' + item.images;
                            }
                        });
                        this.awesomeUsers = response.data.data;
                        this.socket.syncUpdates('user', this.awesomeUsers);
                    }

                });
        } else {
            this.$location.path('main')
        }


    }


    getImage(images) {
        this.$uibModal.open({
            template: maxImageHtml,
            size: 'lg',
            /*@ngInject*/
            controller: function ($scope, $http, $uibModalInstance) {
                $scope.maxImage = images;
                $scope.cancel = function () {
                    $uibModalInstance.close();
                };
            }
        })
    }



    exprotExcel() {
        this.$http.get('/api/users/1/1/', {}).then((response) => {
            if (response.status === 200) {
                console.log(response.data.data);
                this.$timeout(window.open('https://www.bibliagratis.mobi' + response.data.data, "_blank"), 5000)
            }
        }, (error) => {
            console.log(error);
        });
    }


    review(user, index) {
        const awesomeUsers = this.awesomeUsers;
        this.$uibModal.open({
            template: areviewHtml,
            size: 'sm',
            /*@ngInject*/
            controller: function ($scope, $http, $uibModalInstance) {
                $scope.ok = function (status) {
                    let s = parseInt(status, 10);
                    $http.put('/api/users/' + user.user_id + '/' + s + '/', {}).then((response) => {
                        if (response.status === 200) {
                            $uibModalInstance.close(response.data.data);
                        }
                    }, (error) => {
                        console.log(error);
                    });
                };
                $scope.cancel = function (status) {
                    let s = parseInt(status, 10);
                    $http.put('/api/users/' + user.user_id + '/' + s + '/', {}).then((response) => {
                        if (response.status === 200) {
                            $uibModalInstance.close(response.data.data);
                        }
                    }, (error) => {
                        console.log(error);
                    });
                };
            }
        })
            .result.then(function (ret) {
                if (ret) {
                    awesomeUsers[index]['status'] = ret.status;
                }
            }, function () {
            });
    }

    // deleteThing(thing, index) {
    //     this.$http.delete(`/api/things/${thing._id}`).then(response => {
    //         if (response.status === 204) {
    //             this.awesomeUsers.splice(index, 1)
    //         }
    //     }, error => {
    //         console.log(error);
    //     });
    // }

    addUser() {
        const awesomeThings = this.awesomeThings;
        this.$uibModal.open({
            template: addHtml,
            size: 'lg',
            /*@ngInject*/
            controller: function ($scope, $http, $uibModalInstance) {
                $scope.vm = {};
                $scope.save = function (myForm) {
                    if (myForm.$valid === false) {
                        return false;
                    } else {
                        // const test = {
                        //   "device_id": "0f0e65b5-8437-381e-bfe3-ec5fe4488110",
                        //   "email": "",
                        //   "images": "https://graph.facebook.com/v3.2/838673536492614/picture?height=300&width=300&migration_overrides=%7Boctober_2012%3Atrue%7D",
                        //   "pid": "838673536492614",
                        //   "remark": "facebook",
                        //   "user_name": "陈凯华"
                        // }
                        // const user_name = $scope.vm.user_name;
                        $http.post('/api/users', $scope.vm).then((response) => {
                            console.log(response);
                            $uibModalInstance.close(response);
                        }, (error) => {
                            console.log(error);
                        });
                    }
                };
                $scope.cancel = function () {
                    $uibModalInstance.close();
                };
            }
        })
            .result.then(function (ret) {
                if (ret) {
                    //awesomeThings.unshift(ret);
                }
            }, function () {
            });
    }

    deleteUser(user, index) {
        this.$http.delete(`/api/users/${user.user_id}`).then((response => {
            console.log(response);
            if (response.status === 204) {
                this.awesomeUsers.splice(index, 1)
            }
        }, (error) => {
            console.log(error);
        }));
    }
}

export default angular.module('tttApp.user', [uiRouter])
    .config(routing)
    .component('user', {
        template: require('./user.html'),
        controller: UserController
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/user/user.component.js